import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { getTranslation } from "orion-components/i18n";

const DeletePresetDialog = ({ open, onClose, onSave, isSaving, presetName, container }) => {
	const dialogContainer = useMemo(() => {
		const fullscreenElement = document.fullscreenElement;
		const usePlayerContainer =
			container &&
			fullscreenElement &&
			(fullscreenElement === container || fullscreenElement.contains(container));

		return usePlayerContainer ? () => container : undefined;
	}, [container, open]);

	const handleDialogClose = () => {
		if (!isSaving) {
			onClose();
		}
	};

	return (
		<Dialog
			open={open}
			onClose={handleDialogClose}
			container={dialogContainer}
			PaperProps={{
				style: {
					backgroundColor: "#212327",
					padding: "15px",
					minWidth: "420px"
				}
			}} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-preset-dialog-dialog"
		>
			<DialogTitle sx={{ color: "#fff" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-preset-dialog-dialog-title">
				{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.DeletePresetDialog.title")}
			</DialogTitle>
			<DialogContent data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-preset-dialog-dialog-content">
				<Typography sx={{ color: "#fff", mb: 1.5 }}>
					{getTranslation(
						"global.CBComponents.newVideoPlayer.components.mainMenu.DeletePresetDialog.description",
						null,
						presetName || ""
					)}
				</Typography>
			</DialogContent>
			<DialogActions data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-preset-dialog-dialog-actions">
				<Button onClick={handleDialogClose} disabled={isSaving} variant="text" style={{ color: "#B2B6BB" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-preset-dialog-button">
					{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.DeletePresetDialog.cancel")}
				</Button>
				<Button onClick={onSave} disabled={isSaving} variant="contained" sx={{ color: "#fff" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-preset-dialog-button-2">
					{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.DeletePresetDialog.delete")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

DeletePresetDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	isSaving: PropTypes.bool,
	presetName: PropTypes.string,
	container: PropTypes.any
};

DeletePresetDialog.defaultProps = {
	isSaving: false,
	presetName: "",
	container: null
};

export default DeletePresetDialog;
